export const FETCH_SHIPMENT_BY_ORDER_SUCCESS = 'FETCH_SHIPMENT_BY_ORDER_SUCCESS';
export const FETCH_SHIPMENT_BY_ORDER_REQUEST = 'FETCH_SHIPMENT_BY_ORDER_REQUEST';
export const FETCH_SHIPMENT_BY_ORDER_FAILURE = 'FETCH_SHIPMENT_BY_ORDER_FAILURE';
export const FETCH_SHIPMENT_BY_ORDER_RESET = 'FETCH_SHIPMENT_BY_ORDER_RESET';
export const fetchShipmentByOrderSuccess = (payload) => ({
    type: FETCH_SHIPMENT_BY_ORDER_SUCCESS,
    payload,
});
export const fetchShipmentByOrderRequest = (payload) => ({
    type: FETCH_SHIPMENT_BY_ORDER_REQUEST,
    payload,
});
export const fetchShipmentByOrderFailure = (payload) => ({
    type: FETCH_SHIPMENT_BY_ORDER_FAILURE,
    payload,
});
export const fetchShipmentByOrderReset = () => ({
    type: FETCH_SHIPMENT_BY_ORDER_RESET,
});
